"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonTableHeader = void 0;
const React = require("react");
const BronsonTableHeader = (props) => {
    const handleSort = (event, header, index) => {
        event.preventDefault();
        if (header.sortOrder !== undefined && header.sortOrder) {
            header.sortOrder = 0;
        }
        else {
            header.sortOrder = 1;
        }
        const newHeaders = props.headersState ? [...props.headersState] : [];
        newHeaders[index] = header;
        props.setHeadersState && props.setHeadersState([...newHeaders]);
        props.sortFunction && props.sortFunction(header);
    };
    const getSortOrderData = (order) => {
        if (order)
            return 'asc';
        else
            return 'desc';
    };
    const renderHeader = (header, index) => {
        if (header.sortEnabled !== undefined &&
            header.sortEnabled &&
            props.sortFunction &&
            props.setHeadersState &&
            props.headersState) {
            return (React.createElement("button", { className: 'c-btn  c-table__btn  c-table__btn-sort', "data-sort-order": getSortOrderData(header.sortOrder), onClick: (event) => {
                    handleSort(event, header, index);
                } },
                React.createElement("i", { className: 'c-btn__icon' }),
                React.createElement("span", { className: 'c-btn__text' }, header.title)));
        }
        else {
            return React.createElement("span", null, header.title);
        }
    };
    return (React.createElement("thead", { className: props.hideHeaders ? 'u-hide' : '' },
        React.createElement("tr", null, props.headers.map((header, index) => {
            return (React.createElement("th", { className: `bronson-table-th-${index}`, key: index }, renderHeader(header, index)));
        }))));
};
exports.BronsonTableHeader = BronsonTableHeader;
